// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oYfEW","colMin":"styles_colMin__2qKWj"};